module.exports = __webpack_public_path__ + "logotype12.png?82ee4d5164455ca96059b6f85e289452";